import src from "IMAGE";
export default { src, width: 128, height: 128, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAARElEQVR42qWPwQkAIAwD3X+DztYO0NI+23dEf4KgYiCQx5GQhoPaNeDuyMzpiFgBVQURQUTAzDOb2QMwNGqraj/x9aID5vH2GWTT4ckAAAAASUVORK5CYII="};
